import { redirect } from '@tanstack/react-router'
import type { ApiUser } from '@/api/types'
import { hasRole, type Role } from '@/lib/roles'

export function requireRole(role: Role) {
  return ({ context }: { context: { user: ApiUser } }) => {
    if (!hasRole(context.user.roles, role)) throw redirect({ to: '/forbidden' })
  }
}
